import { HttpClient } from "@angular/common/http";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormControl, Validators, NgForm } from "@angular/forms";
import { ApiService } from "src/app/core/services/shared/api.service";
import { NotificationService } from "src/app/core/services/shared/notification.service";
import { HttpService } from "virtue-form";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  styleUrls: ["./forgot-password.component.scss"],
})
export class ForgotPasswordComponent implements OnInit {
  @ViewChild("forgetForm") forgetForm: NgForm;
  isValidField: boolean = false;
  isConfirmPassword: boolean = false;
  isDisabledbtn: boolean = false;
  isLoadingRequest: boolean = false;
  selectdropdown: any;
  orgid: any;
  showUsernameInput: boolean = true;
  showEmailInput: boolean = false;
  username: string = "";
  email: string = "";
  isAccountcheckDropdown: boolean = false;
  Accountchecker: any = [];
  Proceed: string = "";
  // forgotPasswordForm = new FormGroup({
  //   username: new FormControl("", [Validators.minLength(4)]),
  //   email: new FormControl("", [
  //     Validators.required,
  //     // Validators.minLength(4),
  //   ]),
  // });
  // testForm = new FormGroup({
  //   testValue1: new FormControl(true),
  //   testValue2: new FormControl(false),
  //   testValue3: new FormControl(false),
  // });
  constructor(
    public apiService: ApiService,
    private notificatioService: NotificationService,
    private httpser: HttpClient
  ) {}

  ngOnInit(): void {
    if (this.showUsernameInput == true) {
      this.Proceed = "Send Request";
    }
  }

  onClickSendRequest(form: any) {
    if (this.isAccountcheckDropdown == false) {
      if (this.email) {
        this.apiService.checkaccount(this.email).then((res: any) => {
          if (res.accountMissing == false) {
            if (Object.keys(res.multipleAccountOrganisations).length > 1) {
              this.isAccountcheckDropdown = true;
              this.Accountchecker = Object.entries(
                res.multipleAccountOrganisations
              ).map(([key, value]) => ({ id: key, name: value }));
              this.selectdropdown = this.Accountchecker[0].id;
            } else {
              if (res.accountMissing == false) {
                // this.isAccountcheckDropdown = true;
                this.Accountchecker = Object.entries(
                  res.multipleAccountOrganisations
                ).map(([key, value]) => ({ id: key, name: value }));
                this.selectdropdown = this.Accountchecker[0].id;
                this.sendRequest();
              }
            }
          } else {
            if (res.accountMissing == true) {
              this.notificatioService.showNotification(
                "email id is not Exists",
                "not Exist",
                true,
                "error"
              );
            }
          }
        });
      } else {
        if (this.username) {
          this.sendRequest();
        }
      }
    }

    // if (this.isAccountcheckDropdown == true) {
    //   alert("AccountcheckedDropdown");
    //   // this.sendRequest();
    // }
  }
  onCheckboxChange(val: boolean) {
    if (val == true) {
      this.email = "";
      this.Proceed = "Send Request";
    }
    if (val == false) {
      this.username = "";
      this.Proceed = "Proceed";
    }
    this.showUsernameInput = val;
  }
  onInputChange(input: any) {
    this.isAccountcheckDropdown = false;
  }
  sendRequest() {
    this.isLoadingRequest = true;
    console.log(this.forgetForm, "forgetForm");
    this.apiService
      .sendRequestResetPassword(this.forgetForm.value, this.selectdropdown)
      .then(
        (resp) => {},
        (error) => {
          if (error.status == "200") {
            this.notificatioService.showNotification(
              "Password reset request has been mailed to your registered email ID.",
              "Send Request",
              true,
              "success"
            );
            this.isDisabledbtn = false;
            this.isLoadingRequest = false;
          } else {
            this.notificatioService.showNotification(
              "Request to reset password failed, please contact support.",
              "Failed Request",
              true,
              "error"
            );
            this.isDisabledbtn = false;
            this.isLoadingRequest = false;
          }
        }
      );
  }
  sendRequestMultiple() {
    console.log(this.email, "Email meeseege");
    this.isLoadingRequest = true;
    console.log(this.forgetForm, "forgetForm");
    let body: any = {};
    body.email = this.email;
    this.apiService.sendRequestResetPassword(body, this.selectdropdown).then(
      (resp) => {},
      (error) => {
        if (error.status == "200") {
          this.notificatioService.showNotification(
            "Password reset request has been mailed to your registered email ID.",
            "Send Request",
            true,
            "success"
          );
          this.isDisabledbtn = false;
          this.isLoadingRequest = false;
        } else {
          this.notificatioService.showNotification(
            "Request to reset password failed, please contact support.",
            "Failed Request",
            true,
            "error"
          );
          this.isDisabledbtn = false;
          this.isLoadingRequest = false;
        }
      }
    );
  }

  onDropdownChange(selectedValue: any): void {
    this.selectdropdown = selectedValue.target.value;
  }
  back() {
    this.isAccountcheckDropdown = false;
  }
  // vailidatFields() {
  //   if (this.forgotPasswordForm.value.username == "") {
  //     this.isValidField = true;
  //     return false;
  //   } else {
  //     this.isValidField = false;
  //     return true;
  //   }
  // }

  onkeyPressAllowOnlyAlphabet(event: {
    keyCode: number;
    preventDefault: () => void;
  }) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[a-zA-Z ]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
}
